module.exports = "/_next/static/media/ed8294b08fc9375590b38a4b3a485f68.svg";